{
  "id": 36,
  "location": "paris",
  "difficulty": "normal",
  "moves": 22,
  "kinds": 6,
  "goals": [
    { "type": "stain" },
    { "type": "collect", "kind": "donut", "count": 22 }
  ],
  "stars": [2780, 3610],
  "board": [
    ". . . . . . . .",
    ". ~. ~. ~. ~. ~. ~. .",
    ". . ~. ~. ~. ~. . .",
    ". . . # # . . .",
    ". . . # # . . .",
    ". . ~. ~. ~. ~. . .",
    ". ~. ~. ~. ~. ~. ~. .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.686, "movesLeft": 6.1, "closeLosses": 0.216, "target": 0.68 }
}
